<template>
  <main-layout>
    <div>
      <v-tabs
        v-model="viewPage"
        color="white"
        :slider-color="$vuetify.theme.primary"
        style="font-size: 18px"
      >
        <template v-for="(item, index) in filterdMenuItem">
          <template v-if="$store.state.privilege.role">
            <v-tab
              v-if="item.except !== $store.state.privilege.role"
              :key="`menu-item-${index}`"
              style="text-transform: capitalize"
              ripple
              :href="`#${item.view}`"
              @click="updateSlug(item.view)"
              >{{ item.text }}
            </v-tab>
          </template>
          <template v-else>
            <v-tab
              :key="`menu-item-${index}`"
              style="text-transform: capitalize"
              ripple
              :href="`#${item.view}`"
              @click="updateSlug(item.view)"
              >{{ item.text }}
            </v-tab>
          </template>
        </template>
      </v-tabs>

      <!-- <v-container class="mt-4">  -->
      <MembershipOverview v-if="view == 'overview'" />
      <PdpaReport v-if="view == 'pdpa-report'" />
      <!-- </v-container> -->
    </div>
  </main-layout>
</template>

<script>
import MembershipOverview from './MembershipOverview'
import PdpaReport from './PdpaReport'

export default {
  components: {
    MembershipOverview,
    PdpaReport
  },
  data() {
    return {
      viewPage: 'overview',
      menuItem: [
        {
          text: 'Overview Membership',
          view: 'overview'
        },
        {
          text: 'PDPA Report',
          view: 'pdpa-report',
          except: 'staff'
        }
      ]
    }
  },
  computed: {
    filterdMenuItem() {
      return this.menuItem
    },
    view() {
      this.viewPage = this.$route.query.view ? this.$route.query.view : this.filterdMenuItem[0].view
      var result = this.$route.query.view ? this.$route.query.view : this.filterdMenuItem[0].view
      if (this.filterdMenuItem.some((el) => el.view == result)) {
        return result
      } else {
        return this.filterdMenuItem[0].view
      }
    }
  },
  methods: {
    updateSlug(view) {
      if (view !== this.view) {
        this.$router.replace({ query: { view } })
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/lamy/Membership.vue